module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_302939.ece9cb43.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetATF/FormatoSimplificado_302939.pdf
// module id = 810
// module chunks = 0